<app-capture-history-item-title>
  {{ title }}
</app-capture-history-item-title>
<app-capture-history-item-body>
  <p class="phi">
    {{ description }}
  </p>
</app-capture-history-item-body>
